import { LabOrder } from "pwapi";

import {
  LABORDERS_LIST_FAILURE,
  LABORDERS_LIST_REQUEST,
  LABORDERS_LIST_SUCCESS,
} from "../../actions/constants";

export interface LabOrdersState {
  count?: number;
  next?: string;
  previous?: string;
  results: LabOrder[];
  slidesCount?: number;
  loading?: boolean;
}

export const initialState = {
  results: [],
};

const reducer = (state: LabOrdersState = initialState, action: any): any => {
  switch (action.type) {
    case LABORDERS_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case LABORDERS_LIST_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false,
      };
    case LABORDERS_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
